import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// 1. ÖNCE BOOTSTRAP CSS'İ EKLENMELİ (Görünüm için en önemlisi bu)
import 'bootstrap/dist/css/bootstrap.min.css'

// 2. BOOTSTRAP JS'İ EKLENMELİ (Modal, Dropdown gibi hareketli yapılar için)
import * as bootstrap from 'bootstrap'

window.bootstrap = bootstrap
